<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Znajdź szablon produktu
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-autocomplete
                    v-model="productTemplateId"
                    :items="productTemplates"
                    label="Szablon produktu"
                    item-value="id"
                    item-text="name"
                    outlined
                    hide-details
                />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    @click="saveProductTemplate"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'AssignProductTemplateDialog',
    props: {
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            productTemplateId : null
        }
    },
    computed: {
        productTemplates() {
            return this.$store.state.orders.productTemplates.productTemplates
        }
    },
    methods: {
        saveProductTemplate() {
            this.$emit('on-save', {
                productTemplateId : this.productTemplateId,
            })
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>

